module.exports = __webpack_public_path__ + "img/home_icon_inactive.f6b77dbf.svg";